export default function DoubleCheckIcon() {
  return (
    <svg
      width="18"
      height="8"
      viewBox="0 0 18 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.4062 0.90625L4.21875 7.09375L1.125 4.00014M16.875 0.90625L10.6875 7.09375L9.04409 5.45041"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
